<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 19">
  <g clip-path="url(#a)">
    <path fill="#4285F4" d="M5.455 18.005V8.732l-2.876-2.63L0 4.641v11.726c0 .906.734 1.637 1.636 1.637h3.819Z"/>
    <path fill="#34A853" d="M18.545 18.005h3.819c.905 0 1.636-.734 1.636-1.637V4.641l-2.92 1.672-2.535 2.419v9.273Z"/>
    <path fill="#EA4335" d="m5.455 8.732-.392-3.623.392-3.468L12 6.551l6.545-4.91.438 3.28-.438 3.811L12 13.642l-6.545-4.91Z"/>
    <path fill="#FBBC04" d="M18.545 1.641v7.09L24 4.642V2.459C24 .436 21.69-.718 20.073.496L18.545 1.64Z"/>
    <path fill="#C5221F" d="m0 4.641 2.509 1.882 2.946 2.209V1.64L3.927.496C2.307-.718 0 .436 0 2.459v2.182Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path fill="#fff" d="M0 0h24v18.094H0z"/>
    </clipPath>
  </defs>
</svg>
